var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "swiper"], function (require, exports, swiper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    swiper_1 = __importDefault(swiper_1);
    var tabletViewport = 992;
    var swiperMobileMode = Array();
    var swiperActiveSlide = Array();
    var swiperSlideCount = Array();
    $(function () {
        var $swiper;
        $swiper = $('.swiper');
        $swiper.each(function (index, element) {
            var $element = $(element);
            var $swiperid = $element.data('cid') || 0;
            var $swiperloop = !!$element.data('loop') || false;
            var $swiperdelay = $element.data('delay') || 3000;
            var $swiperautoplay;
            if ($element.data('autoplay') > 0) {
                $swiperautoplay = {
                    delay: $swiperdelay
                };
            }
            else {
                $swiperautoplay = false;
            }
            swiperMobileMode[$swiperid] = false;
            swiperActiveSlide[$swiperid] = 0;
            var $mobiletrash = $("#swiper-mobile-" + $swiperid);
            var $fraction = $element.find(".swiper-fraction");
            var $wrapper = $element.find(".swiper-wrapper");
            var $slides = $element.find(".swiper-slide");
            var winWidth = window.innerWidth;
            swiperMobileMode[$swiperid] = checkMobileMode(winWidth, $slides, $wrapper, $mobiletrash, swiperSlideCount[$swiperid], swiperActiveSlide[$swiperid], $fraction, $element, false, swiperMobileMode[$swiperid]);
            /* Umbau bei Viewport-Änderung */
            $(window).on('resize', function () {
                var winWidth = window.innerWidth;
                swiperMobileMode[$swiperid] = checkMobileMode(winWidth, $slides, $wrapper, $mobiletrash, swiperSlideCount[$swiperid], swiperActiveSlide[$swiperid], $fraction, $element, swiper, swiperMobileMode[$swiperid]);
            });
            swiperSlideCount[$swiperid] = calculateFraction($element, $fraction, swiperActiveSlide[$swiperid]);
            /* init Swiper: */
            var swiper = new swiper_1.default(element, {
                loop: $swiperloop,
                autoplay: $swiperautoplay,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    dynamicBullets: false,
                },
                on: {
                    slideChange: function (el) {
                        swiperActiveSlide[$swiperid] = el.realIndex;
                        if ($fraction) {
                            $fraction.html("".concat(el.realIndex + 1, " / ").concat(swiperSlideCount[$swiperid]));
                        }
                    },
                    update: function (el) {
                        el.slideTo(0);
                        swiperSlideCount[$swiperid] = calculateFraction($element, $fraction, 0);
                    }
                }
            });
        });
    });
    /**
     *
     * @param winWidth
     * @param $slides
     * @param $wrapper
     * @param $mobiletrash
     * @param slideCount
     * @param activeSlide
     * @param $fraction
     * @param $element
     * @param swiper
     * @param swiperMobileMode
     */
    function checkMobileMode(winWidth, $slides, $wrapper, $mobiletrash, slideCount, activeSlide, $fraction, $element, swiper, swiperMobileMode) {
        if (winWidth <= tabletViewport) {
            if (!swiperMobileMode) {
                $slides.each(function (index, slide) {
                    var $slide = $(slide);
                    if ($slide.data('splitmobile')) {
                        var $cols = $slide.find('.flexibleGrid_col');
                        $cols.each(function (index, col) {
                            var $col = $(col);
                            var $content = $($col.html());
                            var $newslide = $('<div class="swiper-slide mobile"><div class="swiper-slide-container"><div class="flexibleGrid_row default-gutters"><div class="flexibleGrid_col col-12"></div></div></div></div>');
                            var $newcol = $newslide.find('.flexibleGrid_col');
                            $newcol.append($content);
                            $wrapper.append($newslide);
                        });
                        $slide.appendTo($mobiletrash).addClass('moved');
                        swiperMobileMode = true;
                        if (swiper)
                            swiper.update();
                    }
                });
            }
        }
        else {
            if (swiperMobileMode) {
                $wrapper.empty();
                var $movedslides = $mobiletrash.find('.swiper-slide.moved');
                $movedslides.appendTo($wrapper).removeClass('moved');
                swiperMobileMode = false;
                if (swiper)
                    swiper.update();
            }
        }
        return swiperMobileMode;
    }
    /**
     *
     * @param $element
     * @param $fraction
     * @param activeSlide
     */
    function calculateFraction($element, $fraction, activeSlide) {
        var $slides = $element.find(".swiper-slide");
        var slideCount = $slides.length;
        if ($fraction) {
            $fraction.html("".concat(activeSlide + 1, " / ").concat(slideCount));
        }
        return slideCount;
    }
});
